import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './context/AuthContext';
import { Header } from './components/common/Header';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { PaymentRequired } from './pages/PaymentRequired';
import { Verified } from './pages/Verified';
import { OAuthCallback } from './pages/OAuthCallback';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { Support } from './pages/Support';
import { WhatsNew } from './pages/WhatsNew';
import { AirdropForWindows } from './pages/AirdropForWindows';
import { TransferFilesPhoneToPc } from './pages/TransferFilesPhoneToPc';
import { LocalNetworkFileSharing } from './pages/LocalNetworkFileSharing';
import { FileSharingWithoutCloud } from './pages/FileSharingWithoutCloud';
import { CloudStorageAlternative } from './pages/CloudStorageAlternative';
import { ICloudAlternative } from './pages/ICloudAlternative';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Full-bleed pages that carry their own chrome — don't show the app Header.
const NO_HEADER = [
  '/', '/verified', '/oauth', '/privacy', '/terms', '/support', '/whats-new',
  '/airdrop-for-windows', '/transfer-files-phone-to-pc',
  '/local-network-file-sharing', '/file-sharing-without-the-cloud',
];

function Shell() {
  const location = useLocation();
  // Normalize trailing slashes so /airdrop-for-windows and /airdrop-for-windows/
  // both count (some servers add the slash; the prerender uses the bare path).
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const hideHeader = NO_HEADER.includes(path);
  return (
    <div className="App">
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payment-required" element={<PaymentRequired />} />
        <Route path="/verified" element={<Verified />} />
        <Route path="/oauth" element={<OAuthCallback />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/support" element={<Support />} />
        <Route path="/whats-new" element={<WhatsNew />} />
        <Route path="/airdrop-for-windows" element={<AirdropForWindows />} />
        <Route path="/transfer-files-phone-to-pc" element={<TransferFilesPhoneToPc />} />
        <Route path="/local-network-file-sharing" element={<LocalNetworkFileSharing />} />
        <Route path="/file-sharing-without-the-cloud" element={<FileSharingWithoutCloud />} />
        <Route path="/cloud-storage-alternative" element={<CloudStorageAlternative />} />
        <Route path="/icloud-alternative" element={<ICloudAlternative />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Shell />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
